import { useLocation } from 'react-router-dom';

// Services.
import parseFiltersFromUrl from '@/services/filters/parse-filters-from-url';

/**
 * Returns an object containing the current value of all filters.
 * @returns {object} An object containing filter values.
 */
const useFilters = () => parseFiltersFromUrl(useLocation().search);

export default useFilters;
